export default __webpack_public_path__ + "static/edge-stumbles-3b3229b1ad9355f7d28cc3d3cf43b431.jpg";